import LyDialogButton from './src/index.vue'

LyDialogButton.install = function (Vue) {
    Vue.component(LyDialogButton.name, LyDialogButton)
}

export default LyDialogButton



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/dialog-button/index.js
// module id = null
// module chunks = 